export default "__VITE_ASSET__Bcc9ndGu__"